import React from 'react'
import { Typography, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

const SearchNoAccountFound = () => {
  const { t } = useTranslation()

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{
        height: '100%',
        minHeight: 250,
        padding: 2
      }}
    >
      <Typography>{t('master_filter.no_sites_found')}</Typography>
      <img
        src="/icons/location-question.svg"
        alt="No sites found"
        style={{
          width: '80px',
          color: '#EFEFEF'
        }}
      />
    </Stack>
  )
}

export default SearchNoAccountFound
